import React from 'react';
import BlogListItem from '../BlogListItem';

function RelatedBlogs({ blogs, isLoading }) {
    const renderBlog = (blog) => (
        <BlogListItem
            item={blog}
            key={blog.id}
            isLoading={isLoading}
            cssClassName={`blog-list-item w-full flex justify-center`}
            isRelatedBlog={true}
        />
    );

    return (
        <>
            <h5 className="font-bold text-center text-xl md:text-2xl xl:text-4xl text-primary-500 mt-10 pt-6 lg:pt-8 border-t border-gray-400">
                Related Articles
            </h5>
            <p className="text-xs md:text-sm xl:text-base text-center m-4 xl:m-6 text-gray-600">
                Check out the knowledge base collected and distilled by
                experienced professionals.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 xl:gap-x-14 xl:gap-y-14 h-full pt-2 pb-6">
                {blogs.map(renderBlog)}
            </div>
        </>
    );
}

export default RelatedBlogs;
